// Company / Tenant
export const COMPANY_STATUSES = ["active", "suspended", "archived"];
export const COMPANY_TIERS = ["standard", "premium", "enterprise"];
// Agents
export const AGENT_STATUSES = ["idle", "active", "running", "paused", "pending_approval", "error", "terminated"];
export const RUNTIME_TIERS = ["vm", "container"];
export const AGENT_ROLES = ["general", "ceo", "manager", "ic", "app-builder"];
export const AGENT_ADAPTER_TYPES = [
    "openclaw_gateway",
    "anthropic_native",
    "claude_code",
    "process",
    "http",
];
// Issues / Tasks
export const ISSUE_STATUSES = ["backlog", "todo", "in_progress", "in_review", "blocked", "done", "cancelled"];
export const ISSUE_PRIORITIES = ["urgent", "high", "medium", "low"];
// Projects
export const PROJECT_STATUSES = ["active", "paused", "completed", "archived"];
// Goals
export const GOAL_STATUSES = ["active", "in_progress", "completed", "abandoned"];
export const GOAL_MESSAGE_DIRECTIONS = ["agent_to_human", "human_to_agent"];
export const GOAL_MESSAGE_TYPES = ["question", "update", "blocker", "completion"];
// Agent Tasks
export const AGENT_TASK_TYPES = ["recurring", "one_off"];
export const AGENT_TASK_STATUSES = ["active", "paused", "completed", "failed"];
export const AGENT_TASK_RUN_STATUSES = ["running", "success", "failed", "timeout"];
// Approvals
export const APPROVAL_STATUSES = ["pending", "approved", "rejected", "expired"];
export const APPROVAL_TYPES = ["general", "hire_proposal"];
// Hiring
export const HIRE_TARGET_TYPES = ["existing_instance_subagent", "new_azure_instance"];
export const HIRE_PROPOSAL_STATUSES = ["draft", "pending_approval", "approved", "rejected", "activated"];
/** Valid transitions: from-status → allowed to-statuses */
export const HIRE_PROPOSAL_TRANSITIONS = {
    draft: ["pending_approval"],
    pending_approval: ["approved", "rejected"],
    approved: ["activated"],
    rejected: [],
    activated: [],
};
export const HIRE_PROPOSAL_TERMINAL_STATUSES = ["rejected", "activated"];
// MCP
export const MCP_TRANSPORT_TYPES = ["http", "sse", "stdio"];
// "oauth_signin" = Authorization Code + PKCE flow against the MCP server's
// OWN OAuth authorization server (per the MCP Authorization spec: .well-known
// discovery, optional dynamic client registration, /authorize + /token). An
// admin signs in once interactively; the platform stores the access + refresh
// tokens and vends a fresh bearer to the agent's MCP config. Distinct from
// "oauth_client_credentials" (app-only, no user) — this carries a delegated
// user identity (e.g. OBO downstream) and never touches the M365 service
// identity used for mailbox/Teams.
export const MCP_AUTH_TYPES = [
    "none",
    "api_key",
    "bearer",
    "oauth_client_credentials",
    "oauth_signin",
];
export const MCP_OAUTH_CONNECTION_STATUSES = ["pending", "connected", "error"];
export const MCP_SECRET_SCOPES = ["global", "tenant"];
export const MCP_STATUSES = ["active", "deprecated", "testing"];
// Skills
export const SKILL_TYPES = ["builtin", "custom", "template"];
export const SKILL_STATUSES = ["active", "deprecated"];
// Groups
export const GROUP_SOURCES = ["local", "entra"];
// Auth
export const TENANT_AUTH_PROVIDERS = ["entra", "google", "local"];
// Tenant user roles.
//
// New three-tier model (introduced in migration 0056):
//   tenant_admin  — sees and manages every agent in the tenant, manages
//                   users/groups/integrations, can grant agent access.
//   agent_admin   — manages only agents they have an agent_access row for
//                   (directly or via group); can also manage the tenant
//                   skill + MCP catalogues and create subagents on agents
//                   they own. Cannot create new top-level agents (no VM
//                   provisioning) and cannot manage users/groups.
//   standard_user — chat-only with the agents they have access to. No
//                   settings cog anywhere in the UI.
//
// Legacy values (admin/editor/viewer) are NOT accepted on new writes —
// migration 0056 rewrites them in place. The server-side role hierarchy
// still accepts the old names as aliases for one release to keep older
// JWT/session shapes from breaking, but the canonical names are below.
export const TENANT_USER_ROLES = ["tenant_admin", "agent_admin", "standard_user"];
export const TENANT_USER_ROLE_LABELS = {
    tenant_admin: "Tenant admin",
    agent_admin: "Agent admin",
    standard_user: "Standard user",
};
export const TENANT_USER_ROLE_DESCRIPTIONS = {
    tenant_admin: "Sees and manages every agent. Manages users, groups, integrations, and agent access.",
    agent_admin: "Manages only agents they have been granted access to. Can manage tenant-level skills + MCP servers and create subagents on accessible agents.",
    standard_user: "Chat-only access to assigned agents. No settings.",
};
export const PLATFORM_ROLES = ["platform_admin", "platform_support", "platform_billing"];
// Azure
export const AZURE_DEPLOYMENT_STATUSES = [
    "pending", "provisioning", "running", "stopped", "deallocated", "failed", "deleted",
];
export const AZURE_RESOURCE_TYPES = ["vm", "container_app"];
// Run State Machine
export const RUN_STATUSES = ["queued", "running", "completed", "failed", "cancelled", "timed_out"];
/** Valid transitions: from-status → allowed to-statuses */
export const RUN_TRANSITIONS = {
    queued: ["running", "cancelled"],
    running: ["completed", "failed", "cancelled", "timed_out"],
    completed: [],
    failed: [],
    cancelled: [],
    timed_out: [],
};
export const RUN_TERMINAL_STATUSES = ["completed", "failed", "cancelled", "timed_out"];
export const RUN_EVENT_TYPES = [
    "run.created", "run.started", "run.completed", "run.failed",
    "run.cancelled", "run.timed_out", "run.heartbeat",
];
// Chat
export const CHAT_ROLES = ["user", "assistant", "system"];
// Activity
export const ACTIVITY_ACTIONS = [
    "agent.created", "agent.updated", "agent.deleted",
    "issue.created", "issue.updated", "issue.status_changed", "issue.assigned",
    "approval.created", "approval.decided",
    "mcp.assigned", "mcp.removed",
    "skill.assigned", "skill.removed",
    "deployment.created", "deployment.started", "deployment.stopped", "deployment.deleted",
    "hire.proposed", "hire.approved", "hire.rejected", "hire.activated",
    "tenant.created", "tenant.updated",
    "user.login", "user.impersonation",
];
//# sourceMappingURL=constants.js.map